import CorrosionLogService from 'features/wells/corrosion/helpers/corrosionlogs.service';
import { CORROSION_LOG_ACTIONS } from 'features/wells/corrosion/helpers/corrosionlogs.constants';

import { NOTIFICATION_VARIANTS } from 'app/app.constants';

export const loadCorrosionLogTemplate = () => (dispatch) => {
  const payload = CorrosionLogService.loadCorrosionLogTemplate();

  dispatch({
    payload,
    type: CORROSION_LOG_ACTIONS.LOAD_CORROSION_LOG_TEMPLATE,
    notification: {
      [NOTIFICATION_VARIANTS.INFO]: 'Downloading template...',
      [NOTIFICATION_VARIANTS.ERROR]: 'Failed to download the template.',
    },
  });

  return payload;
};

export const loadServiceProviders = () => (dispatch) => {
  try {
    const payload = CorrosionLogService.loadServiceProviders();

    dispatch({
      payload,
      type: CORROSION_LOG_ACTIONS.LOAD_SERVICE_PROVIDERS,
    });
  } catch (error) {
    dispatch({
      type: CORROSION_LOG_ACTIONS.LOAD_ALL_ELEMENTS_LIST,
      payload: {},
      error: true,
    });
  }
};

export const loadCorrosionMeasureTools = () => (dispatch) => {
  try {
    const payload = CorrosionLogService.loadCorrosionMeasureTools();

    dispatch({
      payload,
      type: CORROSION_LOG_ACTIONS.LOAD_CORROSION_MEASURE_TOOLS,
    });
  } catch (error) {
    dispatch({
      type: CORROSION_LOG_ACTIONS.LOAD_CORROSION_MEASURE_TOOLS,
      payload: {},
      error: true,
    });
  }
};

export const createNewServiceProvider = (serviceProvider) => (dispatch) => {
  try {
    const payload = CorrosionLogService.createServiceProviders({
      name: serviceProvider,
    });

    dispatch({
      payload,
      type: CORROSION_LOG_ACTIONS.CREATE_NEW_SERVICE_PROVIDER,
    });
  } catch (error) {
    dispatch({
      payload: {},
      type: CORROSION_LOG_ACTIONS.CREATE_NEW_SERVICE_PROVIDER,
      error: true,
    });
  }
};

export const createNewCorrosionMeasureTool = (tool) => (dispatch) => {
  try {
    const payload = CorrosionLogService.createCorrosionMeasureTool({
      name: tool,
    });

    dispatch({
      payload,
      type: CORROSION_LOG_ACTIONS.CREATE_NEW_CORROSION_MEASURE_TOOL,
    });
  } catch (error) {
    dispatch({
      payload: {},
      type: CORROSION_LOG_ACTIONS.CREATE_NEW_CORROSION_MEASURE_TOOL,
      error: true,
    });
  }
};

export const createNewCorrosionLog =
  (file, data, toggleDrawer) => (dispatch) => {
    const payload = CorrosionLogService.createNewCorrosionLog(file, data).then(
      () => {
        toggleDrawer();
        dispatch(loadCorrosionLogs(data.wellId));
      },
    );
    dispatch({
      payload,
      type: CORROSION_LOG_ACTIONS.LOAD_CORROSION_LOG_TEMPLATE,
      notification: {
        [NOTIFICATION_VARIANTS.SUCCESS]: 'Created log successfully',
        [NOTIFICATION_VARIANTS.INFO]: 'Creating log...',
        [NOTIFICATION_VARIANTS.ERROR]: 'Failed to create log.',
      },
    });

    return payload;
  };

export const loadCorrosionLogs = (wellId) => (dispatch) => {
  try {
    const payload = CorrosionLogService.loadCorrosionLogsByWell(wellId);

    dispatch({
      payload,
      type: CORROSION_LOG_ACTIONS.LOAD_CORROSION_LOGS_LIST,
    });
  } catch (error) {
    dispatch({
      type: CORROSION_LOG_ACTIONS.LOAD_CORROSION_LOGS_LIST,
      payload: {},
      error: true,
    });
  }
};

export const deleteCorrosionLog =
  (fileId, setDeleteFlag, deleteFlag) => (dispatch) => {
    dispatch({
      fileId,
      type: CORROSION_LOG_ACTIONS.DELETE_CORROSION_LOG,
      confirmationDialog: {
        title: 'Delete log',
        confirmButtonText: 'Delete',
        description: 'Are you sure you want to delete this corrosion log?',
      },
      notification: {
        [NOTIFICATION_VARIANTS.INFO]: 'Removing log..',
        [NOTIFICATION_VARIANTS.SUCCESS]: 'Log Removed.',
        [NOTIFICATION_VARIANTS.ERROR]: 'Failed to remove corrosion log.',
      },
      payload: () =>
        CorrosionLogService.deleteCorrosionLog(fileId).then(() =>
          setDeleteFlag(!deleteFlag),
        ),
    });
  };

export const loadCorrosionLogFile = (fileId) => (dispatch) => {
  const payload = CorrosionLogService.loadCorrosionLogFile(fileId);

  dispatch({
    payload,
    type: CORROSION_LOG_ACTIONS.LOAD_CORROSION_LOG_FILE,
    notification: {
      [NOTIFICATION_VARIANTS.INFO]: 'Downloading log file..',
      [NOTIFICATION_VARIANTS.ERROR]: 'Failed to download log file.',
    },
  });

  return payload;
};

export const loadCorrosionLogFilters = (files) => (dispatch) => {
  try {
    const payload = CorrosionLogService.loadCorrosionLogFilters(files);

    dispatch({
      payload,
      type: CORROSION_LOG_ACTIONS.LOAD_CORROSION_LOGS_FILTERS,
    });
  } catch (error) {
    dispatch({
      type: CORROSION_LOG_ACTIONS.LOAD_CORROSION_LOGS_FILTERS,
      payload: {},
      error: true,
    });
  }
};

export const loadCompareFilesData = (filters) => (dispatch) => {
  try {
    const payload = CorrosionLogService.loadCompareFilesData(filters);

    dispatch({
      payload,
      type: CORROSION_LOG_ACTIONS.LOAD_COMPARE_FILES_DATA,
    });
  } catch (error) {
    dispatch({
      type: CORROSION_LOG_ACTIONS.LOAD_COMPARE_FILES_DATA,
      payload: {},
      error: true,
    });
  }
};
